import { render, staticRenderFns } from "./titleItem.vue?vue&type=template&id=9f8fafc0&scoped=true"
import script from "./titleItem.vue?vue&type=script&lang=js"
export * from "./titleItem.vue?vue&type=script&lang=js"
import style0 from "./titleItem.vue?vue&type=style&index=0&id=9f8fafc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8fafc0",
  null
  
)

export default component.exports